export const VA_TIMEZONE_PH = 'Asia/Manila';
export const VA_TIMEZONE_AMS = 'Europe/Amsterdam';
export const DEFAULT_VA_TIMEZONE = VA_TIMEZONE_AMS;
export const MAX_SCHEDULE_HOURS = 6;
export const MAX_SCHEDULE_MINUTES = MAX_SCHEDULE_HOURS * 60;

export const VA_TIMEZONE_OPTIONS = [
  { id: VA_TIMEZONE_PH, label: 'Philippines (PH)' },
  { id: VA_TIMEZONE_AMS, label: 'Amsterdam (AMS)' }
];

export function shiftDurationMinutes(start, end) {
  if (!start || !end) return 0;
  const [sh, sm] = start.split(':').map(Number);
  const [eh, em] = end.split(':').map(Number);
  if ([sh, sm, eh, em].some((n) => Number.isNaN(n))) return 0;
  return Math.max(0, (eh * 60 + em) - (sh * 60 + sm));
}

export function formatShiftDuration(minutes) {
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  if (m === 0) return `${h}h`;
  return `${h}h ${m}m`;
}
